import { useState } from "react";
import {
  AmazonItemsStatusreceiptGetTaskProgressPostRequest,
  AmazonItemsApi,
  ResponseGetTaskProgressResponse,
  RequestGetTaskProgressRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetTaskProgress = () => {
  const [taskProgressCounts, setTaskProgressCounts] = useState<
  ResponseGetTaskProgressResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchTaskProgress = async (
    requestParams: RequestGetTaskProgressRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: AmazonItemsStatusreceiptGetTaskProgressPostRequest = {
        req: requestParams,
      };

      const api = new AmazonItemsApi(config);
      const response = await api.amazonItemsStatusreceiptGetTaskProgressPost(
        request
      );
      setTaskProgressCounts(response);
      return response;
    } catch (err) {
      setError("作業進捗状況を取得出来ませんでした。");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { taskProgressCounts, fetchTaskProgress, error, isLoading };
};
